








































import { Vue } from "vue-property-decorator"
import type { url } from "@/@types/base"
import TsUpload from "@/components/upload.vue";

export default Vue.extend({
  name: "StadiumPhotoUpload",
  components: { TsUpload },
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    correct : { type: Object, default() { return {} } },
  },
  data() {
    return {
      host       : "https://data.taisam.cn",
      empty_url  : { path: "", url : "" } as url,
      change_urls: [
        { path: "", url : "" } as url
      ],
      stadium_photo: [
        { path: "", url : "" } as url
      ],
      change: {} as any,
      show  : true
    }
  },
  computed: {
    if_correct() {
      return ((): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.change, "registration_urls")) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      })
    }
  },
  methods: {
    init(data: any, change: any) {
      let   paths = []
      const urls  = []
      /* 附件5：场馆经营照片证明材料 */
      if (data.stadium_photo_urls && data.stadium_photo_urls.length > 0) paths = data.stadium_photo_urls
      if (change != undefined && !Object.prototype.hasOwnProperty.call(change, "stadium_photo_urls")) this.show = false
      for (const v of paths) {
        if (v != "") {
          const p = v.replace(this.host, "")
          urls.push({ path: p, url: `${this.host}${p}` })
        }
      }
      urls.push(this.empty_url)
      this.stadium_photo = urls
    },
    show_correct(): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.change, "registration_urls")) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    handleChange(path: string, index: number) {
      if (path == "") {
        const temp = this.$deep_copy(this.stadium_photo)
        this.stadium_photo = []
        for (const k in temp) {
          if (k != String(index)) {
            if (Object.prototype.hasOwnProperty.call(temp, k)) {
              this.stadium_photo.push(temp[k])
            }
          }
        }
      } else this.stadium_photo[index] = { path, url: this.host + path }
      if (this.correct.id == undefined) this.submit()
      this.change = this.$deep_copy(this.correct)
      this.add_upload(this.stadium_photo)
    },
    add_upload(urls: url[]) {
      let count = 0
      for (const v of urls) {
        if (v.path == "") count += 1
      }
      if (count == 0) {
        urls.push({ path: "", url: "" })
      }
    },
    /* 处理 URL */
    handleURLS(data: url[]):string {
      const urls = []
      for (const v of data) if (v.path != "") urls.push(v.path)
      return urls.join(",")
    },
    submit() {
      const params = { estimate_id: this.id, stadium_photo_urls: this.handleURLS(this.stadium_photo) }
      this.$emit("modify", params)
    },
    check(): boolean {
      return this.stadium_photo.length > 1
    },
  },
  watch: {
    correct: {
      handler() {
        this.change = this.$deep_copy(this.correct)
        if (Object.prototype.hasOwnProperty.call(this.correct, "registration_urls")) {
          const paths = this.correct.registration_urls
          const urls  = []
          for (const v of paths) {
            if (v != "") {
              const p = v.replace(this.host, "")
              urls.push({ path: p, url: `${this.host}${p}` })
            }
          }
          this.change_urls = urls
        }
      },
      deep: true
    }
  }
})

